import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { buildEdgeAuthStartUrl } from '@cortex/core-types';
import { authApi } from '../lib/api.js';
import { queryKeys } from '../lib/query-keys.js';

/**
 * @graph-stack mall
 * @graph-domain Operations
 * @graph-business 認証フック。/auth/meでセッション検証・login/logoutミューテーション提供
 * @graph-connects authApi [calls] 認証APIクライアント経由でログイン・ログアウト・セッション取得
 * @graph-connects queryKeys [calls] TanStack Queryキー生成
 */
export function useAuth() {
  const queryClient = useQueryClient();

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: queryKeys.auth.me(),
    queryFn: authApi.getCurrentUser,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  const loginMutation = useMutation({
    mutationFn: () => {
      window.location.href = buildEdgeAuthStartUrl(window.location.href);
      return Promise.resolve();
    },
  });

  const logoutMutation = useMutation({
    mutationFn: authApi.logout,
    onSuccess: () => {
      queryClient.setQueryData(queryKeys.auth.me(), null);
      window.location.href = '/login';
    },
  });

  const user = data?.user ?? null;

  return {
    user,
    expiresAt: data?.expiresAt,
    isAuthenticated: !!user,
    isLoading,
    error,
    refetch,
    login: loginMutation.mutate,
    logout: logoutMutation.mutate,
    isLoggingIn: loginMutation.isPending,
    isLoggingOut: logoutMutation.isPending,
  };
}
